<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <ActionButton
        class="m-1"
        text="Crear Requisición"
        variant="success"
        i="fas fa-file-plus"
        @click="goToAddRequisition()"
      />
    </page-header>
    <FilterManager
      ref="filterManager"
      v-model="filters"
      :filters="filtersHeader"
      :display-advanced="false"
      @search="onSearch"
    />
    <separator class="my-3" text="Resultado de Requisiciones" />
    <custom-result-not-found v-if="result.data.length === 0" />
    <search-result
      :result-data="result"
      @do-search="getRequisitionsData"
      @on-page-change="onPageChangeHandler"
    />
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import academicYearService from '@/services/academicyear';
import codeService from '@/modules/common/code.api';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';
import Separator from 'custom-separator';
import SearchResult from './components/SearchResult';
import { getSearchRequisitionsResult } from '@/modules/materials-equipment/api.js';

export default {
  name: 'MainMaterialsEquipmentRequisition',
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
    CustomResultNotFound,
    Separator,
    SearchResult,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Manejo de Requisición de Materiales y Equipos',
        routes: [
          'Inicio',
          'PEI',
          'Manejo de Requisición de Materiales y Equipos',
        ],
      },
      collections: {
        fiscalYears: [],
        status: [],
        requisitionTypes: [],
      },
      filters: {
        fiscalYear: null,
        status: null,
        requisitionType: null,
        searchField: null,
      },
      result: {
        data: [],
        pagination: {},
      },
    };
  },
  computed: {
    filtersHeader() {
      return [
        {
          name: 'fiscalYear',
          component: 'CustomDropDown',
          options: this.collections.fiscalYears,
          value: this.filters.fiscalYear,
          placeholder: 'Seleccione Año Fiscal',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          class: 'col-sm-6 col-md-6 col-lg-3 ml-0 mr-0',
          classContainer: 'w-100',
          validations: 'required',
          mapParentValue: this.filters.fiscalYear == null,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.collections.status,
          value: this.filters.status,
          placeholder: 'Seleccione Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-6 col-md-6 col-lg-3 ml-0 mr-0',
          classContainer: 'w-100',
          mapParentValue: this.filters.status == null,
        },
        {
          name: 'requisitionType',
          component: 'CustomDropDown',
          options: this.collections.requisitionTypes,
          value: this.filters.requisitionType,
          placeholder: 'Seleccione Tipo de Requisición',
          class: 'col-sm-6 col-md-6 col-lg-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.requisitionType == null,
        },
        {
          name: 'searchField',
          component: 'CustomInput',
          placeholder: 'Escriba Número de Requisición',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-sm-6 col-md-6 col-lg-3',
          type: 'text',
        },
      ];
    },
  },
  methods: {
    goToAddRequisition() {
      const self = this;
      self.$router.push({
        name: 'materialAddRequisition',
      });
    },
    async fetchResources() {
      const {
        data: fiscalYears,
      } = await academicYearService.getAcademicYearFromMin({
        minYearId: 24,
      });
      this.collections.fiscalYears = fiscalYears;
      this.filters.fiscalYear = fiscalYears.find((e) => e.selected);

      const {
        data: requisitionStatus,
      } = await codeService.getMaterialsequipmentRequisitionStatus();
      this.collections.status = requisitionStatus;

      const {
        data: requisitionTypes,
      } = await codeService.getMaterialsequipmentRequisitionTypes();
      this.collections.requisitionTypes = requisitionTypes;
    },
    onSearch() {
      this.getRequisitionsData();
    },
    onPageChangeHandler(page) {
      this.getRequisitionsData(page);
    },
    async getRequisitionsData(pageIndex = 1) {
      let payload = {
        fiscalYearId: this.filters.fiscalYear?.id,
        statusId: this.filters.status?.id,
        requisitionTypeId: this.filters.requisitionType?.id,
        searchCriteria: this.filters.searchField,
        pageIndex: pageIndex,
        pageSize: 20,
      };
      let { data: response } = await getSearchRequisitionsResult(payload);
      this.result = {
        data: response.data,
        pagination: {
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: 20,
        },
      };
    },
  },
  mounted() {
    this.fetchResources();
  },
};
</script>
